import React, { useState } from 'react';
import DefaultReactSelect from 'components/Utils/DefaultReactSelect';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';

const PlaceholderField = ({ element, updateField, disabled }) => {
  const [placeholderText, setPlaceholderText] = useState();
  const [openPlaceholder, setOpenPlaceholder] = useState(false);

  const { placeholder = '', id, type } = element;
  const placeholderLabel = DocumentTemplateUtils.getPlaceholderLabel(placeholder);

  return (
    <DefaultReactSelect
      key={placeholder || id}
      value={{
        value: placeholder || '',
        label: placeholderText || placeholderLabel,
      }}
      defaultInputValue={placeholderLabel || ''}
      inputValue={placeholderText || ''}
      menuIsOpen={openPlaceholder || false}
      setMenuOpen={(value) => setOpenPlaceholder(value)}
      loading={false}
      placeholder="Placeholders..."
      onChange={(item) => {
        setPlaceholderText(undefined);
        updateField(id, { placeholder: item.value });
      }}
      onInputChange={(value) => setPlaceholderText(value)}
      options={DocumentTemplateUtils.getPlaceholderList(type)}
      disabled={disabled}
    />
  );
};
export default PlaceholderField;
